import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

const File = ({ ncrId, id, file, callBackFunctionDelete, upload }) => {
  return (
    <Row className={'mb-2'}>
      <Col xs={10}>
        <FormControl key={id} disabled defaultValue={upload ? file.path : file.name} />
      </Col>
      <Col xs={2}>
        {
          upload ?
            <Button
              id={id}
              className='w-100'
              variant='warning'
              onClick={event => {
                event.preventDefault();
                callBackFunctionDelete();
              }}
            >X</Button>
            :
            <Button
              className='w-100'
              id={id}
              href={`/api/ncr/${ncrId}/getFile/${file.id}`}
              variant='warning'
            >
              ↓
            </Button>
        }
      </Col>
    </Row>
  )
}

export { File };
